import { userService } from '../../helpers/authservice/user.service';
import router from '../../router/index'
import { apiAuth } from '../../constants'
import axios from "axios";

const user = JSON.parse(localStorage.getItem('user'));
export const state = user ?
    { status: { loggeduser: true }, user } :
    { status: {}, user: null };

export const actions = {
    // Logs in the user.
    // eslint-disable-next-line no-unused-vars
    login({ dispatch, commit }, { email, password }) {
        commit('loginRequest', { email });
        let urlAuth = `${apiAuth}/api/user/login`
        // eslint-disable-next-line
        console.log(urlAuth)
        // eslint-disable-next-line
        console.log("HACIENDO LOGIN")
        axios
            .post(urlAuth, {
                user: email,
                pass: password,
            })
            .then(r => {
                //console.log(r)
                return r.data
            })
            .then(res => {   
                //console.log(res) 
                if(res.valid){
                    userService.loginExtern(res)
                    commit('loginSuccess', res);
                    this.$socket.client.emit('add user', res);
                    router.push({path:'/welly/resto'})
                }else{
                    commit('loginFailure', res);
                    dispatch('notification/error', res, { root: true });
                }
            });
    },
    // Logout the user
    logout({ commit }) {
        userService.logout();
        commit('logout');
    },
    // register the user
    /*
    registeruser({ dispatch, commit }, user) {
        commit('registerRequest', user);
        userService.register(user)
            .then(
                user => {
                    commit('registerSuccess', user);
                    dispatch('notification/success', 'Registration successful', { root: true });
                    router.push('/login');
                },
                error => {
                    commit('registerFailure', error);
                    dispatch('notification/error', error, { root: true });
                }
            );
    }
    */
};

export const mutations = {
    loginRequest(state, user) {
        state.status = { loggingIn: true };
        state.user = user;
    },
    loginSuccess(state, user) {
        state.status = { loggeduser: true };
        state.user = user;
    },
    loginFailure(state) {
        state.status = {};
        state.user = null;
    },
    logout(state) {
        state.status = {};
        state.user = null;
    },
};